import gql from 'graphql-tag';
import { BookingsFragmentInclude } from './Bookings';

export default gql`

    fragment Audiovisual on Funeral {
        Audiovisuals {
            ${BookingsFragmentInclude}
        }
    }
`;
